<h3 class="title">New User Details</h3>
@if ($newUserHasSubmittedForm()) {
<div class="after-submission">
  <p>
    <strong>{{ newContact.name.first }} {{ newContact.name.last }}</strong> has been sent an invitation email. Upon
    clicking the invitation link in that email, he/she will be given instructions to complete their profile and access
    the Customer Portal.
  </p>
  <div class="actions">
    <button type="button" class="naked" (click)="modalClosed.emit()"><span>I'm finished</span></button>
    <button type="button" class="oneok-button oneok-pill oneok-blue mt-3" (click)="clearFormSubmission()">
      <span>Invite Another Contact</span>
    </button>
  </div>
</div>
} @if ($existingUserHasSubmittedForm()) {
<div class="after-submission">
  <p>
    <strong>{{ newContact.name.first }} {{ newContact.name.last }}</strong> has been added as a user of the {{
    accountName }} account
  </p>
  <div class="actions">
    <button type="button" class="naked" (click)="modalClosed.emit()"><span>I'm finished</span></button>
    <button type="button" class="oneok-button oneok-pill oneok-blue mt-3" (click)="clearFormSubmission()">
      <span>Add Another User</span>
    </button>
  </div>
</div>
} @if ($userHasTriggeredDocusignWorkflow()) {
<div class="after-submission">
  <p>
    An email from DocuSign with instructions for executing an Electronic Systems Access Agreement for
    <strong> {{ accountName }} </strong> has been sent to you. Once completed you will be enabled to add new users
  </p>
  <div class="actions">
    <button type="button" class="naked" (click)="modalClosed.emit()"><span>I'm finished</span></button>
  </div>
</div>
} @if (isAddNewUserFormShown()) {
<form [formGroup]="newContactForm" (ngSubmit)="onNewContactSubmission(newContactForm.value, $event)">
  <div class="split-controls half">
    <div class="form-pair">
      <label for="firstName">First Name</label>
      <input type="text" id="firstName" formControlName="firstName" required />
    </div>
    <div class="form-pair">
      <label for="lastName">Last Name</label>
      <input type="text" id="lastName" formControlName="lastName" required />
    </div>
  </div>
  <div class="form-pair">
    <label for="email">Work Email</label>
    <input type="email" id="email" formControlName="email" required />
    <span class="invalid-feedback mx-2">
      @if (newContactForm.get('email')?.errors?.validateEmail) {
      <span>This user already exists on this account</span>
      } @if (newContactForm.get('email')?.errors?.pattern) {
      <span>Please enter a valid Email</span>
      }
    </span>
  </div>

  <div class="form-radio-list">
    <label for="role0">What kind of access should this person have?</label>
    @for (contactPortalRole of contactPortalRoles.controls; track contactPortalRole; let contactPortalRoleIdx = $index)
    {
    <div class="form-pair">
      <input
        type="checkbox"
        value="true"
        [id]="'role' + contactPortalRoleIdx"
        [formControl]="$any(contactPortalRole)"
      />
      <label [for]="'role' + contactPortalRoleIdx">
        @if (!contactPortalRole.value) {
        <svg-icon src="/assets/svg/square.svg" />
        } @if (contactPortalRole.value) {
        <svg-icon src="/assets/svg/square-check-outline.svg" />
        }
        <span>{{ $accountRoles()[contactPortalRoleIdx].name }}</span>
      </label>
    </div>
    }
  </div>
  <button type="submit" class="oneok-button oneok-pill oneok-blue" [disabled]="!newContactForm.valid">
    <svg-icon src="/assets/svg/user-plus.svg" />
    <span>Add new user</span>
  </button>
</form>
} @if (isGrandfatherEsaaComponentShown()) {
<div class="after-submission">
  @if (accountEsaaStatus === 'Sent') {
  <p>
    A new Electronic Systems Access Agreement has been sent to
    <strong>
      @if ($esaaSigner(); as esaaSigner) { {{ esaaSigner.name.full }} } @else { an authorized administrator }
    </strong>
    on behalf of
    <strong>{{ accountName }} </strong>. Once the ESAA is signed and authorized you will be enabled to add new users.
    Contact Customer Portal Support if you have questions.
  </p>
  <div class="actions">
    <button type="button" class="naked" (click)="modalClosed.emit()"><span>I'm finished</span></button>
  </div>
  }@else{
  <p>
    A newly executed Electronic Systems Access Agreement is required for <strong>{{ accountName }} </strong> in order to
    add a new user to this account.
  </p>
  <div class="actions">
    <button
      type="submit"
      class="oneok-button oneok-pill oneok-blue mt-3"
      (click)="sendDocuSignESAAToAccountAdmin($event)"
    >
      <span>Send DocuSign ESAA</span>
    </button>
  </div>
  }
</div>
}
